import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectFinSobData = createSelector(
  [selectFinancialCockpitState],
  ({ finSobData }) => finSobData
)
